import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { CountBubble } from '@/components/ui';
import { NAV_ITEMS, NAV_ALIASES } from './navItems';
import { useNavBadges } from './useNavBadges';

/** Phone bottom bar (80px) with the raised orange Jual action in the centre. */
export const TabBar: React.FC = () => {
    const { t } = useTranslation();
    const badges = useNavBadges();
    const { pathname } = useLocation();
    const current = pathname === '/held-carts' ? '/settings' : (NAV_ALIASES[pathname] ?? pathname);

    return (
        <nav className="fixed inset-x-0 bottom-0 z-40 grid h-20 grid-cols-5 items-center border-t border-line-subtle bg-surface-card px-1.5 pb-1.5 safe-bottom lg:hidden">
            {NAV_ITEMS.filter((item) => !item.railOnly).map((item) => {
                const active = current.startsWith(item.to);
                const count = item.badge ? badges[item.badge] : 0;
                if (item.primary) {
                    return (
                        <NavLink key={item.to} to={item.to} aria-current={active ? 'page' : undefined} className="-mt-[30px] flex flex-col items-center gap-1 text-[11px] font-black text-ink-accent">
                            <span className="relative flex h-[60px] w-[60px] items-center justify-center rounded-full border-4 border-surface-card bg-accent-500 text-ink-onAccent shadow-accent transition-transform active:scale-[.94]">
                                <item.icon className="h-[26px] w-[26px]" />
                                <CountBubble count={count} tone="danger" className="absolute -top-1 -right-1 border-2 border-surface-card !h-5 !min-w-[20px]" />
                            </span>
                            {t(item.labelKey)}
                        </NavLink>
                    );
                }
                return (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        aria-current={active ? 'page' : undefined}
                        className={clsx('flex flex-col items-center gap-1 text-[11px] transition-colors', active ? 'font-extrabold text-ink-brand' : 'font-bold text-ink-muted')}
                    >
                        <span className={clsx('relative flex rounded-pill px-3.5 py-[3px]', active && 'bg-brandsoft')}>
                            <item.icon className="h-[22px] w-[22px]" />
                            <CountBubble count={count} tone="danger" className="absolute -top-1.5 right-1" />
                        </span>
                        {t(item.labelKey)}
                    </NavLink>
                );
            })}
        </nav>
    );
};
export default TabBar;
